import {VisitAPIDataSource} from '../api/VisitAPIDataSource';
import {mapVisitDTOToModel} from '../mappers/visit.mapper';
import {Visit} from '../models/visit.model';

export class GetStoreVisitHistoryUseCase {
  async execute (storeId: string | number): Promise<Visit[]> {
    const dtos = await VisitAPIDataSource.getStoreVisitHistory(storeId);
    return dtos.map(mapVisitDTOToModel);
  }
}
